module.exports = __webpack_public_path__ + "img/botton.a38527a6.png";